/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import CommunicationOptions from './CommunicationOptions';

import { actions as systemNotificationActions } from '../../../redux/ducks/systemNotification';
import { selectors as userSelectors, actions as userActions } from '../../../redux/ducks/user';
import { selectors as policySelectors } from '../../../redux/ducks/policy';
import NavigationActions from '../../redux/NavigationActions';
import RouteNames from '../../RouteNames';
import userApi from '../../../../apiServices/UserService';

function mapStateToProps(state, routerProps) {
  const user = userSelectors.getUser(state);

  return {
    userData: user.data,
    onFinish: () => {
      NavigationActions.goBack(routerProps.history, RouteNames.accountSettings());
    },
    onCancel: () => {
      NavigationActions.goBackTo(routerProps.history, RouteNames.accountSettings());
    },
    getPolicyByName: (name) => policySelectors.getPolicyByName(state, name)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateUser: (userData, callback) => {
      dispatch(userActions.submitUserUpdate(userData, (apiError) => {
        if (apiError) {
          dispatch(systemNotificationActions.showNotification());
          this.props.showNotification(apiError.messageKey());
        }
        callback(apiError);
      }));
    },
    onAccept: (userId, policies, callback) => {
      userApi.consent(userId, policies).then(callback);
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CommunicationOptions);
